// @file This store manages screen recording in a more minimal sense compared to surface_screen_recorder_store.ts which it is based on
/**
 * This store is used to handle the case where a user is recording their screen for a single post (no draft/comment handling)
 * note: this store assumes there will only be one screen recording session at a time for a user
 */

import { defineStore } from 'pinia'
import { ref } from 'vue'

export enum ScreenRecorderStatus {
  Hidden = 'Hidden',
  Connecting = 'Connecting',
  Streaming = 'Streaming',
  Recording = 'Recording',
  Paused = 'Paused',
  Previewing = 'Previewing',
  Saving = 'Saving',
}

export const useScreenRecorderStore = defineStore('screenRecorderStore', () => {
  // #region: visibility for screen recorder modal
  const isVisible = ref(false)
  const showScreenRecorder = (): void => {
    isVisible.value = true
    status.value = ScreenRecorderStatus.Connecting
  }
  const hideScreenRecorder = (): void => {
    isVisible.value = false
    status.value = ScreenRecorderStatus.Hidden
  }
  // #endregion

  // #region status for screen recorder modal
  const status = ref<ScreenRecorderStatus>(ScreenRecorderStatus.Hidden)
  const setStatus = (newStatus: ScreenRecorderStatus): void => {
    status.value = newStatus
  }
  // #endregion

  // #region: z index override for screen recorder modal
  const zIndexOverride = ref<number | null>(null)
  const setZIndexOverride = (zIndex: number | null): void => {
    zIndexOverride.value = zIndex
  }
  // #endregion

  return {
    // visibility
    isVisible,
    zIndexOverride,
    setZIndexOverride,
    showScreenRecorder,
    hideScreenRecorder,

    // status
    status,
    setStatus,
  }
})
